import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import './menu-dropdown.css'
import classnames from 'classnames';

class SideMenuDropdown extends Component {
    constructor(props) {
        super(props);

        this.toggle = this.toggle.bind(this);
    }

    renderClasses() {
        let {className} = this.props;

        if (!className) return '';

        if (Array.isArray(classnames)) {
            className = classnames.join(' ');
        }

        return className;
    }

    toggle(event) {
        this.props.handleOpen(this.props.toggleKey);
    }

    render() {
        let {title, href} = this.props;
        href = href || '#';
        return (
            <li className={this.renderClasses() + (this.props.open ? ' open' : '' )}>
                <Link className="title" onClick={this.toggle} to={href}>{title}</Link>
                <ul className={'inner-list' + (this.props.open ? ' open' : '' )}>
                    {this.props.children}
                </ul>
            </li>
        )
    };
}

export default SideMenuDropdown;


// WEBPACK FOOTER //
// ./src/components/sidenav/menu-dropdown/index.jsx